import { ReduxStore } from 'store/types';

function editIsLoading(state: ReduxStore): boolean {
  return state.intervention.edit.config.isLoading;
}

export default editIsLoading;
